import { c as _c } from "react/compiler-runtime";
import type { Drawer } from '@base-ui/react/drawer';
import type { ReactNode, RefObject } from 'react';
import { SideDrawer } from 'shared/components/side-drawer';
import { twMerge } from 'tailwind-merge';
interface NavbarDrawerProps {
  actionsRef: RefObject<Drawer.Root.Actions | null>;
  children: ReactNode;
  className?: string;
}
export function NavbarDrawer(t0) {
  const $ = _c(8);
  const {
    actionsRef,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("border-border-200 bg-bg-primary shadow-2 tablet:max-w-95 w-full border-t", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== actionsRef) {
    t2 = () => actionsRef.current?.close();
    $[2] = actionsRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <SideDrawer className={t1} onClose={t2} side="right" underNavbar={true}>{children}</SideDrawer>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}